// extracted by mini-css-extract-plugin
export default {"background":"Footer_background__XMXpe","footerDes":"Footer_footerDes__anZaU"};